import React from "react";
import { InputFactory as Factory } from "../../nq-component";
import { findObjectUseCase, saveObjectUseCase } from "../../usecases/object";
import { saveFileUseCase, saveImageUseCase } from "../../usecases/file";
import Context from "../../AppContext";
import InputPassword from "../InputPassword";
import InputUsername from "../InputUsername";
import InputImageArray from "../InputImagesArray";
import InputPointer from "../InputPointer";
import InputSelect from "../InputSelect";
import DateRange from "../DateRange";
import InputFileMultiple from "../InputMultipleFile";
import InputRelation from "../InputRelation";
import RelatedFactory from "../RelatedFactory";
import InputString from "../InputString";
import InputRate from "../InputRate";

const defaultProps = {};
function InputFactory({ type, _type, field, object, onChange, ...props }) {
  const context = React.useContext(Context);
  const value = object && object[field];

  function _onChange(field, value) {
    if (object) {
      object[field] = value;
    }
    onChange(value, field);
  }

  switch (_type || type) {
    case "Related":
      return (
        <RelatedFactory
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          field={field}
          {...props}
        />
      );
    case "Relation":
      return (
        <InputRelation
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          // required={_required || required}
          {...props}
        />
      );
    case "Username":
      return (
        <InputUsername
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          required
          {...props}
        />
      );
    case "Password":
      return (
        <InputPassword
          required
          onChange={_onChange.bind(this, field)}
          {...props}
        />
      );

    case "ImageArray":
      return (
        <InputImageArray
          value={value}
          saveImage={saveImageUseCase()}
          onChange={_onChange.bind(this, field)}
          {...props}
        />
      );

    case "Affis":
      return (
        <InputPointer
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          findObject={findObjectUseCase()}
          {...props}
        />
      );
    case "RelatedAffi":
      return (
        <InputPointer
          defaultValue={value}
          objectRelated={object}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          schema={
            props.schema ||
            context.schemas.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          findObject={findObjectUseCase()}
          {...props}
        />
      );

    case "Enum":
      return (
        <InputSelect
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          placeholder={
            props.placeholder ||
            (props.dynamic ? "Select of type " : "Select ") +
              (props.label || field)
          }
          {...props}
        />
      );

    case "MultipleFile":
    case "InputFile":
      return (
        <InputFileMultiple
          value={value}
          onChange={_onChange.bind(this, field)}
          // required={_required || required}
          {...props}
        />
      );
    case "Rate":
      return (
        <InputRate
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          // required={required}
          {...props}
        />
      );

    default:
      return (
        // <></>
        <Factory
          type={type}
          _type={_type}
          field={field}
          object={object}
          schemas={context.schemas}
          onChange={onChange}
          findObject={findObjectUseCase()}
          saveObject={saveObjectUseCase()}
          saveImage={saveImageUseCase()}
          saveFile={saveFileUseCase()}
          {...props}
        />
      );
  }
}

InputFactory.defaultProps = defaultProps;
export default InputFactory;
